import { useRemoveTag } from "@/queries/episodes/use-tags";
import { useTagModalStore } from "@/stores/tag-modal-store";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export function TagDialog() {
  const { isOpen, tagModalData, closeModal, setIsTagRemovePending } =
    useTagModalStore();
  const { mutate: removeTag } = useRemoveTag();

  const handleConfirm = () => {
    setIsTagRemovePending(true);
    removeTag(
      {
        episodeIds: tagModalData?.episodeIds || [],
        tag: tagModalData?.name || "",
      },
      {
        onSettled: () => {
          setIsTagRemovePending(false);
        },
      },
    );
    closeModal();
  };

  return (
    <Dialog open={isOpen} onClose={closeModal}>
      <DialogTitle>Remove Tag</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to remove the tag "{tagModalData?.name}"?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
